import React from 'react';
import CallToAction from "@scentregroup/ui/components/call-to-action";
import Heading from "@scentregroup/ui/components/heading";
import { kebabCase } from 'lodash';
import { Stack } from '@hub/stack';
import { Box } from '@hub/box';
import { incBaseIdentity } from '../../helpers/paths';
import ExternalLink from '../external-link';
import { LinkSection } from './link-section';
import * as paths from './paths';
import style from './index.module.scss';
import { trackUniversalFooterLinkClick } from './analytics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LOGIN = incBaseIdentity('login');
const REGISTER = incBaseIdentity('register');
const westfieldPlusSection = {
  heading: {
    text: 'Westfield Plus',
    url: paths.WESTFIELD_PLUS,
    newTab: true
  },
  links: [{
    text: 'Login',
    url: LOGIN,
    trackingLabel: 'Westfield Plus Login'
  }, {
    text: 'Join',
    url: REGISTER,
    trackingLabel: 'Westfield Plus Join link'
  }, {
    text: 'Terms and Conditions',
    url: paths.TERMS_CONDITIONS_WESTFIELD_PLUS,
    newTab: false
  }, {
    text: 'Privacy statement',
    url: paths.PRIVACY_POLICY_WESTFIELD_PLUS,
    newTab: false
  }, {
    text: 'FAQs',
    url: paths.FAQS_WESTFIELD_PLUS,
    newTab: true
  }]
};
export const WestfieldPlusContainer = ({
  country
}) => /*#__PURE__*/_jsxs(Stack, {
  shouldWrapChildren: false,
  sx: {
    flexGrow: 1,
    marginTop: ['spacing-xl', 0]
  },
  children: [country === 'Australia' && /*#__PURE__*/_jsx(Box, {
    as: "nav",
    "aria-labelledby": kebabCase(westfieldPlusSection.heading.text),
    sx: {
      marginBottom: 'spacing-xl'
    },
    children: /*#__PURE__*/_jsx(LinkSection, {
      heading: westfieldPlusSection.heading,
      links: westfieldPlusSection.links,
      trackers: {
        clicked: trackUniversalFooterLinkClick
      }
    })
  }), /*#__PURE__*/_jsxs("div", {
    className: style.joinSection,
    children: [/*#__PURE__*/_jsx(Heading, {
      type: "small",
      className: style.joinTitle,
      children: "Get more every day with Westfield Plus"
    }), /*#__PURE__*/_jsx(CallToAction, {
      inverted: true,
      fullWidth: true,
      element: ExternalLink,
      className: style.joinButton,
      url: country === 'Australia' ? REGISTER : paths.WESTFIELD_PLUS,
      "data-test-id": "subscribe-button",
      "aria-label": "Join Westfield Plus",
      onClick: () => trackUniversalFooterLinkClick('Westfield Plus Join button'),
      children: "Join"
    })]
  })]
});